export const SIZES = {
    l: 'h2',
    m: 'h3',
    s: 'body',
};
export const FONTS = {
    regular: 'regular',
    semibold: 'semibold',
};
//# sourceMappingURL=constants.js.map